import { Applicant } from "../../types/loan-documents";
import { DocumentStage, VerificationStatus } from "./loan-documents.consts";

function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

export const getUnverifiedDocumentsInStage = (
  applicants: Applicant[],
  documentStage: DocumentStage
) => {
  return applicants.flatMap((applicant) =>
    applicant.requiredDocuments
      .filter(
        (requiredDocument) =>
          requiredDocument &&
          requiredDocument.stage === documentStage &&
          requiredDocument.verificationStatus === VerificationStatus.UNVERIFIED
      )
      .filter(nonNullable)
  );
};
